const React = require('react');
const PropTypes = require('prop-types');
const { connect } = require('react-redux');
const { FormattedText, formatText } = require('core/i18n').i18n;
const FormattedDescription = require('components/commons/FormattedDescription');
const { formatAmount } = require('utilities/currencyHelper');
const TabbedBoxContent = require('components/commons/tabbedBox/tabbedBoxContent/tabbedBoxContent');
const { selected: assetAllocationSelected } = require('../../actions/assetAllocation');
const { selected: countryExposureSelected } = require('../../actions/countryExposure');
const AssetAllocationsChart = require('components/charts/AssetAllocationsChart/AssetAllocationsChart');
const AssetAllocationsTable = require('components/charts/AssetAllocationsTable/AssetAllocationsTable');
const CountryExposureChart = require('components/charts/CountryExposureChart/CountryExposureChart');
const CountryExposureTable = require('components/charts/CountryExposureTable/CountryExposureTable');
const PortfolioHoldingsTable = require('components/charts/PortfolioHoldingsTable/PortfolioHoldingsTable');
const MarketCapitalBreakdownTable = require('components/charts/MarketCapitalBreakdownTable/MarketCapitalBreakdownTable');
const { GRAPH_COLORS } = require('../../constants');
const {
    getAssetAllocations,
    getCountryExposureData,
    getMarketCapitalBreakdownData,
    getPortfolioHoldings,
} = require('../../selectors/fundDataSelectors');

require('./TabAssets.scss');
import withFeatureToggling from 'hocs/withFeatureToggling/withFeatureToggling'
const { FUND_GLOSSARY } = require('constants/flagBasedFeatures')

class TabAssets extends React.Component {
    render() {
        const {
            assetAllocations,
            countryExposureData,
            marketCapitalBreakdownData,
            portfolioHoldings,
            selectAssetAllocation,
            selectedAssetAllocation,
            selectCountryExposure,
            selectedCountryExposure,
            flagBasedFeatures
        } = this.props;

        if(!assetAllocations) return null

        let countryData = countryExposureData;

        if (countryData) {
            countryData.sort(function (a, b) {
                if (a.value < b.value) {
                return 1;
                }
                if (a.value > b.value) {
                return -1;
                }
                return 0;
            });
        }

        let sortPortfolios = portfolioHoldings.sort((a,b) => parseFloat(b.weighting) - parseFloat(a.weighting)).slice(0, 5);
        const labelSearchName = flagBasedFeatures.get(FUND_GLOSSARY)
            ? <FormattedDescription value="fundsCard-updatedInformationDisclaimer" />
            : <FormattedDescription value="fundsCard-updatedInformationDisclaimerNoGlossary" />

        return (
            <TabbedBoxContent visible>
                <div className="tabassets">
                    <section className="row">
                        <div className="col-lg-8 col-xs-12">
                            <h3 className="tabassets--title">{formatText('fundsCard-assetsAllocationTitle')}</h3>
                            <p className="tabassets--description">
                                <FormattedDescription value="fundsCard-assetsAllocationDescription" />
                            </p>
                            <span className="tabassets--allocation">
                                <AssetAllocationsTable
                                    colors={GRAPH_COLORS}
                                    data={assetAllocations.sort((a, b) => parseInt(a.type) >= parseInt(b.type))}
                                    onMouseEnterRow={i => selectAssetAllocation(i)}
                                />
                            </span>
                        </div>
                        <div className="col-lg-4 col-xs-12">
                            <AssetAllocationsChart
                                activeIndex={selectedAssetAllocation}
                                colors={GRAPH_COLORS}
                                data={assetAllocations}
                            />
                        </div>
                        <div className="col-xs-12">
                            <p className="tabassets--description mt--50">
                                <FormattedDescription value="fundsCard-assetsAllocationAddend" />
                            </p>
                        </div>
                    </section>
                    <section className="row">
                        <div className="col-lg-12 col-xs-12">
                            <h3 className="tabassets--title mt--50">{formatText('fundsCard-countryExposureTitle')}</h3>
                            <p className="tabassets--description">
                                <FormattedDescription value="fundsCard-countryExposureDescription" />
                            </p>
                        </div>
                        <div className="col-lg-6 col-xs-12">
                            <div className="tabassets--exposure">
                                <CountryExposureTable
                                    data={countryData}
                                    onMouseEnterRow={selectCountryExposure}
                                />
                            </div>
                        </div>
                        <div className="col-lg-6 col-xs-12 tabassets--map">
                            <CountryExposureChart
                                data={countryData}
                                countrySelected={selectedCountryExposure}
                            />
                        </div>
                    </section>
                    <section className="row">
                        <div className="col-lg-12 col-xs-12">
                            <h3 className="tabassets--title mt--50">{formatText('fundsCard-portfolioHoldingsTitle')}</h3>
                            <p className="tabassets--description">
                                <FormattedDescription value="fundsCard-portfolioHoldingsDescription" />
                            </p>
                            <span className="tabassets--holdings">
                                <PortfolioHoldingsTable data={sortPortfolios} />
                            </span>
                            {sortPortfolios !== undefined &&
                            <aside className="holdings--footer">
                                <FormattedText
                                    value="fundsCard-portfolioHoldingsSum"
                                    injectedStrings={[formatAmount(sortPortfolios.reduce((sum, ph) => sum + ph.weighting, 0))]}
                                />
                            </aside>}
                        </div>
                    </section>
                    <section className="row">
                        <div className="col-lg-12 col-xs-12">
                            <h3 className="tabassets--title mt--50">{formatText('fundsCard-marketStocksTitle')}</h3>
                            <p className="tabassets--description">
                                <FormattedDescription value="fundsCard-marketStocksDescription" />
                            </p>
                            <span className="tabassets--capital">
                                {marketCapitalBreakdownData !== null &&
                                    <MarketCapitalBreakdownTable data={marketCapitalBreakdownData} />
                                }
                            </span>
                        </div>
                    </section>
                    <section className="row">
                        <div className="col-lg-12 col-xs-12 tabfees__information">
                            <p className="information__card information__card--footer">
                                {labelSearchName}
                            </p>
                        </div>
                    </section>
                </div>
            </TabbedBoxContent>
        )
    }
}


TabAssets.propTypes = {
    assetAllocations: PropTypes.array,
    countryExposureData: PropTypes.array,
    portfolioHoldings: PropTypes.array,
    marketCapitalBreakdownData: PropTypes.array,
    selectAssetAllocation: PropTypes.func.isRequired,
    selectedAssetAllocation: PropTypes.number.isRequired,
    selectCountryExposure: PropTypes.func.isRequired,
    selectedCountryExposure: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
    flagBasedFeatures: PropTypes.object.isRequired
};

TabAssets.defaultProps = {
    assetAllocations: [],
    countryExposureData: [],
    portfolioHoldings: [],
    marketCapitalBreakdownData: [],
};

const mapStateToProps = (state, props) => ({
    assetAllocations: getAssetAllocations(state, props),
    countryExposureData: getCountryExposureData(state, props),
    marketCapitalBreakdownData: getMarketCapitalBreakdownData(state, props),
    portfolioHoldings: getPortfolioHoldings(state, props),
    selectedAssetAllocation: state.brokerInvestmentFundView.selectedAssetAllocation,
    selectedCountryExposure: state.brokerInvestmentFundView.selectedCountryExposure,
});

const mapDispatchToProps = dispatch => ({
    selectAssetAllocation: index => dispatch(assetAllocationSelected({ index })),
    selectCountryExposure: id => dispatch(countryExposureSelected({ id })),
});


module.exports = connect(mapStateToProps, mapDispatchToProps)(withFeatureToggling(TabAssets))
